module.exports = __webpack_public_path__ + "static/media/contactos.b4336c5c.svg";